import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentinpune() {



const cardData = {
  keyword: "Kia Carens On Rent in Pune",
  heading: "Lotus Cab: Kia Carens On Rent in Pune",

  headingDescription:
    "Lotus Cab offers premium and comfortable Kia Carens on rent in Pune for family travel, airport transfers, corporate trips, and long-distance outstation journeys. The Kia Carens is a modern MPV available in 6 and 7 seater configurations, designed with luxurious interiors, spacious seating, advanced safety features, and smooth suspension for both city and highway driving. Whether you need a stylish airport pickup, a comfortable vehicle for weekend getaways, or a reliable MPV for business travel, our chauffeur-driven Kia Carens ensures a refined and stress-free ride. All vehicles are regularly serviced, sanitized, and maintained for maximum safety and comfort. We provide transparent per-kilometer pricing with flexible one-way and round-trip packages. With punctual doorstep pickup anywhere in Pune and easy online booking support, Lotus Cab makes Kia Carens rental convenient, safe, and affordable.",

  top: "Top Places to Visit in Pune with Kia Carens Rental",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is one of Pune’s most iconic historical landmarks and a must-visit destination for families and tourists. Kia Carens rental allows your entire family to travel together comfortably in a premium MPV. Spacious seating and air-conditioned interiors ensure relaxed city travel even during peak hours. The vehicle’s smooth suspension provides comfortable ride quality across Pune roads. Lotus Cab offers flexible waiting time for sightseeing visits."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is a serene historical monument linked to India’s freedom struggle. Kia Carens offers premium interior comfort suitable for family and educational visits. Spacious legroom and modern design enhance the travel experience. Professional drivers ensure punctual and safe transportation."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a popular trekking and weekend getaway near Pune. Kia Carens offers stable highway and ghat performance, making it suitable for hill drives. Comfortable seating ensures stress-free travel for groups."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "Khadakwasla Dam is a scenic picnic spot perfect for family outings. Kia Carens rental ensures spacious seating and smooth suburban travel. Ideal for weekend relaxation trips."
    },
    {
      title: "Lavasa",
      description:
        "Lavasa is a beautiful hill city near Pune ideal for weekend trips. Kia Carens provides refined highway driving performance and superior cabin comfort."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a popular expressway destination. Kia Carens ensures comfortable and safe travel with advanced safety features and premium interiors."
    },
    {
      title: "Mahabaleshwar",
      description:
        "Mahabaleshwar is a favorite hill station for family vacations. Kia Carens rental provides spacious seating and luggage support for long-distance travel."
    },
    {
      title: "Shirdi",
      description:
        "Shirdi pilgrimage trips are comfortable with Kia Carens MPV offering smooth highway performance and comfortable seating."
    },
    {
      title: "Imagicaa",
      description:
        "Imagicaa theme park trips become more enjoyable with spacious family travel in Kia Carens."
    },
    {
      title: "Pune Airport",
      description:
        "Kia Carens airport transfer service is ideal for family airport pickup and drop with ample luggage space."
    }
  ],

  services: [
    {
      name: "Kia Carens On Rent in Pune",
      description:
        "Book Kia Carens on rent in Pune for premium 6 and 7 seater MPV travel. The vehicle offers spacious interiors, comfortable seating, advanced safety features, and smooth driving performance suitable for city and highway journeys. Ideal for families, business travelers, and group trips. Fully air-conditioned interiors provide comfort during all seasons. Professional chauffeur included with transparent per-km pricing and flexible booking options."
    },
    {
      name: "Kia Carens Taxi Pune",
      description:
        "Kia Carens taxi service in Pune provides stylish and comfortable MPV travel for daily commuting and special occasions. Spacious cabin ensures relaxed seating for passengers. AC interiors and smooth suspension enhance overall ride comfort. Suitable for both personal and business travel."
    },
    {
      name: "Kia Carens for Outstation Pune",
      description:
        "Reliable Kia Carens outstation cab service from Pune to major cities and tourist destinations. Stable highway performance and luggage capacity make it perfect for long-distance family trips. Flexible one-way and round-trip packages available."
    },
    {
      name: "Kia Carens Airport Transfer Pune",
      description:
        "Punctual Kia Carens airport pickup and drop service with adequate luggage space. Ideal for family and corporate airport transfers with comfortable AC interiors and professional drivers."
    },
    {
      name: "6 Seater Kia Carens Pune",
      description:
        "6 seater Kia Carens configuration offers captain seats and enhanced comfort for premium family travel. Spacious layout ensures relaxed long-distance journeys."
    },
    {
      name: "7 Seater Kia Carens Pune",
      description:
        "7 seater Kia Carens provides flexible seating arrangement ideal for group travel. Comfortable cabin and luggage support available."
    },
    {
      name: "Corporate Kia Carens Cab Pune",
      description:
        "Professional Kia Carens rental for corporate meetings, executive travel, and business events. Premium interiors and punctual service guaranteed."
    },
    {
      name: "Online Kia Carens Booking Pune",
      description:
        "Instant online booking with quick confirmation and 24/7 customer support assistance for seamless rental experience."
    }
  ],

  tableData: [
    ["Kia Carens On Rent in Pune", "Kia Carens Taxi Pune"],
    ["Kia Carens for Outstation Pune", "Kia Carens Airport Transfer Pune"],
    ["6 Seater Kia Carens Pune", "7 Seater Kia Carens Pune"],
    ["Affordable Kia Carens Rental Pune", "Kia Carens Per Km Rate Pune"],
    ["AC Kia Carens Taxi Pune", "Chauffeur Driven Kia Carens Pune"],
    ["Family Trip Kia Carens Pune", "Corporate Kia Carens Cab Pune"]
  ],

  whychoose: [
    { WhyChooseheading: "Premium 6 & 7 Seater Comfort", WhyChoosedescription: "Spacious MPV seating with modern interiors ensures comfortable family and group travel." },
    { WhyChooseheading: "Advanced Safety Features", WhyChoosedescription: "Equipped with modern safety systems for secure city and highway journeys." },
    { WhyChooseheading: "Professional Chauffeurs", WhyChoosedescription: "Trained and experienced drivers ensure punctual and safe transportation." },
    { WhyChooseheading: "Transparent Per Km Pricing", WhyChoosedescription: "Clear fare structure with no hidden charges." },
    { WhyChooseheading: "Ideal for Family & Corporate Travel", WhyChoosedescription: "Suitable for business meetings, airport transfers, and weekend trips." },
    { WhyChooseheading: "AC Comfort All Seasons", WhyChoosedescription: "Fully air-conditioned interiors for relaxed travel experience." },
    { WhyChooseheading: "Well-Maintained Fleet", WhyChoosedescription: "Regular servicing and sanitization ensures safety and hygiene." },
    { WhyChooseheading: "24/7 Customer Support", WhyChoosedescription: "Round-the-clock booking assistance available." }
  ]
};

const faqData = [
  { question: "Is Kia Carens suitable for family trips?", answer: "Yes, spacious 6 and 7 seater configuration makes it ideal for family travel." },
  { question: "Is airport transfer available?", answer: "Yes, Kia Carens available for Pune airport pickup and drop." },
  { question: "Is driver included?", answer: "Yes, professional chauffeur included with every booking." },
  { question: "Is outstation travel available?", answer: "Yes, Kia Carens available for long-distance trips." },
  { question: "Is AC available?", answer: "Yes, fully air-conditioned MPV provided." },
  { question: "Is pricing transparent?", answer: "Yes, clear per-km pricing without hidden charges." },
  { question: "Is corporate booking allowed?", answer: "Yes, suitable for corporate travel and meetings." },
  { question: "Is online booking available?", answer: "Yes, instant online booking system available." },
  { question: "Is vehicle sanitized?", answer: "Yes, regularly cleaned and maintained." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock assistance provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Kulkarni",
    feedback:
      "Booked Kia Carens for family trip to Mahabaleshwar. The vehicle was spacious, clean, and extremely comfortable. Driver was professional and punctual. Highly recommended for family travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Patil",
    feedback:
      "Used Kia Carens for airport transfer with luggage. Excellent space and smooth ride quality. Very premium experience at reasonable pricing.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Professional Kia Carens service for business travel. Clean interiors and timely pickup made the trip hassle-free.",
    rating: 5
  }
];














































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens On Rent in Pune",
  "image": "https://lotuscab.com/assets/images/kia-carens-on-rent-pune.jpg", 
  "description": "Lotus Cab offers Kia Carens on rent in Pune for airport transfers, outstation trips, family travel, and corporate use. Choose from 6-seater and 7-seater AC MPVs with chauffeur service, affordable per km rates, and easy online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/kia-carens-on-rent-pune"
  }
};





  return (
    <div>
      


<Helmet>
  <title>Contact: +91 8767592195 | Kia Carens On Rent in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Rent Kia Carens in Pune with Lotus Cab. 6 & 7-seater AC MPVs for airport, outstation, family & corporate trips. Chauffeur included. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Kia Carens On Rent in Pune, Kia Carens Taxi Pune, Kia Carens for Outstation Pune, Kia Carens Airport Transfer Pune, 6 Seater Kia Carens Pune, 7 Seater Kia Carens Pune, Affordable Kia Carens Rental Pune, Kia Carens Per Km Rate Pune, AC Kia Carens Taxi Pune, Chauffeur Driven Kia Carens Pune, Family Trip Kia Carens Pune, Corporate Kia Carens Cab Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarenceonrentinpune;